import { render, staticRenderFns } from "./HomeSlide.vue?vue&type=template&id=3824a775&scoped=true&"
import script from "./HomeSlide.vue?vue&type=script&lang=js&"
export * from "./HomeSlide.vue?vue&type=script&lang=js&"
import style0 from "./HomeSlide.vue?vue&type=style&index=0&id=3824a775&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3824a775",
  null
  
)

export default component.exports